import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import { HelmetProvider } from "react-helmet-async";
import { ApolloClient, HydrationHelper } from "core/utils";
import { App } from "app/App";
import { typePolicies } from "app";
import { InMemoryHeadCacheController } from "app/InMemoryHeadCacheController";
import { UniversalHeadController } from "app/UniversalHeadController";
import { ClientRenderDetailsController } from "./ClientRenderDetailsController";
import { ClientHeadAssetIncluder } from "./ClientHeadAssetIncluder";
export var Root = function (_a) {
    var helmetContext = _a.helmetContext, apolloStateFromServer = _a.apolloStateFromServer, appStateFromServer = _a.appStateFromServer;
    return (React.createElement(HydrationHelper.Provider, null,
        React.createElement(HelmetProvider, { context: helmetContext },
            React.createElement(BrowserRouter, null,
                React.createElement(ApolloProvider, { client: ApolloClient.createApolloClient(apolloStateFromServer, typePolicies) },
                    React.createElement(App, { appState: appStateFromServer, detailsController: new ClientRenderDetailsController(), headController: new UniversalHeadController(new InMemoryHeadCacheController(appStateFromServer.headCache), new ClientHeadAssetIncluder(document)) }))))));
};
